import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
    Col,
    Row,
    Container,
    Modal,
} from "reactstrap";
import { toast } from "react-toastify";

import { getAllAgendaList, updateAgendaItem } from "../../../api/casp/agenda";
import { PaginationComponent } from "../common/PaginationComponent";
import { Skeleton } from "@mui/material";
import { DefaultPerPageValue } from "../../../constants/Common";
import dayjs from 'dayjs';

import { BoardName } from "../../../constants/Board";
import { AllStatusList } from "../../../api/casp/status";
import SearchDropDownListPaginationComponent from "../common/SearchDropDownPaginationList";
import { getAllProject } from "../../../api/casp/project";
import { Role } from "../../../constants/Role";
import FormControl from '@mui/material/FormControl';
import { getAllPortfolios } from "../../../api/casp/portfolio";
import { ProjectStatuses } from "../../../constants/Status";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CreateAgenda from "./CreateAgenda";
import EditAgenda from "./EditAgenda";
import NodataFound from "../../../Components/Common/NoDataFound";
import Ticket from "../../../assets/images/icons/error.png";
import AgendaAccordionComponent from "./AgendaAccordion";
import { unSetCurrentProjectRole } from "../../../store/roles";
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import { Helmet } from 'react-helmet';
import InsertChartOutlinedOutlinedIcon from '@mui/icons-material/InsertChartOutlinedOutlined';
import { getIconPath } from "../../../helpers/file_helper";
import { withTranslation } from "react-i18next";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import Button from "@mui/material/Button";
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import { useNavigate } from "react-router-dom";

const TodoList = (props) => {
    const [openCreateAgendaModal, setOpenCreateAgendaModal] = useState(false);
    const { user } = useSelector((state) => ({
        user: state.Profile.user,
    }));
    const dispatch = useDispatch()
    const [agendaList, setAgendaList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
    const [paginationObject, setPaginationObject] = useState({});
    const [agendaLoading, setAgendaLoading] = useState(false);

    const [agendaCreationLoading, setAgendaCreationLoading] = useState(false);
    const [statusList, setStatusList] = useState([])
    const [filterProjectId, setFilterProjectId] = useState(null)
    const [filterPortfolioId, setFilterPortfolioId] = useState(null)
    const [filterDate, setFilterDate] = useState(null)
    const [openedAgendas, setOpenedAgendas] = useState([])
    const [editAgendaId, setEditAgendaId] = useState('')
    const [openEditAgendaModal, setOpenEditAgendaModal] = useState(false);
    const [reloadAccordion, setReloadAccordion] = useState({});
    const [sendReloadAccordion, setSendReloadAccordion] = useState({date:'', id:''});
    const [action, setAction] = useState(null);
    const [openedDates, setOpenedDates] = useState([]);
    const [key, setKey] = useState(+new Date());
    const navigate = useNavigate();

    // console.log(user,'user');
    

    const currentProjectRole = useSelector((state) => state.Roles.currentProjectRole)


    const toggleAgendaEditModal = (receiveAgendaId) => {
        setOpenEditAgendaModal((p) => !p);
        setEditAgendaId(receiveAgendaId)
    };

    const toggleAgendaCreationModal = () => {
        setOpenCreateAgendaModal((p) => !p);
    };

    const toggleAgendas = (id) => {
        const isOpen = openedAgendas.includes(id);
        if (isOpen) {
            // If already open, close it (remove ID from the array)
            setOpenedAgendas((prevOpenAccordions) =>
                [...prevOpenAccordions.filter((accordionId) => accordionId !== id)]
            );

        } else {
         setOpenedAgendas((prevOpenAccordions) => [...prevOpenAccordions, id]);

        }


    };

    useEffect(() => {
        if(currentProjectRole?.role !== Role.EPMO_MANAGER && currentProjectRole?.role !== Role.ROOT_ADMIN &&  currentProjectRole?.role !== Role.EPMO_OFFICER && currentProjectRole?.role !== Role.PROGRAM_MANAGER && currentProjectRole?.role !== Role.PRESIDENT && currentProjectRole?.role !== Role.VICE_PRESIDENT && currentProjectRole?.role !== Role.MENTOR){
            dispatch(unSetCurrentProjectRole())
        }
        getStatusList()
    }, []);

    useEffect(() => {
        getAllAgenda()
    }, [filterPortfolioId, filterProjectId, filterDate])

    useEffect(()=>{

        if(action !== null){
            accordionIdModify()
        }

    },[action])


    const getStatusList = async () => {
        try {
            const statusApiParams = {
                filterFields: ['board'],
                filterInputs: [BoardName.TODO]
            }
            const res = await AllStatusList(statusApiParams);
            if (res.data.data.data.length > 0) {
                setStatusList(res.data.data.data)
            }
        } catch (error) {
            console.log(error);
        }
    }

    /**
     *
     * @param {{ date: '', page: 0, perPage: 10 }} params date is used to fetch agenda items for each date,
     * page is used for paginating data
     * perPage is used for listing n number of data at per page
     * @param  paginationData this is used as a flag when changing a page then the global page value
     * is ignored and used page no from object argument
     */
    const getAllAgenda = async (params = { page: 0, perPage: rowsPerPage }, paginationData = false, date = '') => {
        try {
            setAgendaLoading((p) => !p)
            params = {
                ...params,
                companyId: user.company.id,
                ...(!paginationData &&
                    { page: (page + 1) })
            }
            if (filterDate && dayjs(filterDate).isValid()) {
                params.filterFields = 'date'
                params.filterInputs = filterDate
            }

            if (filterProjectId) {
                params.projectIds = [filterProjectId]
                params.projectSpecific = true
            } else {
                params.projectSpecific = false
            }

            if (filterPortfolioId) {
                params.portfolioIds = [filterPortfolioId]
            }


            const res = await getAllAgendaList(params);

            if(date !== ''){

               date = date.format('YYYY-MM-DD')

            }

            const findAgendaOnChange = agendaList.find((ag) => ag.date.split('T')[0] === date);
            const newAgendaList = res.data.data.data.map((_d, index) => {

                let findAgendaFromList = agendaList.find((ag) => ag.date === _d.date);

                let agendaKey = findAgendaFromList ? findAgendaFromList?.agendaKey : `${index + 1}_${+new Date()}`;
                if (findAgendaFromList && findAgendaOnChange && findAgendaFromList?.date === findAgendaOnChange?.date) {
                    agendaKey = `${index + 1}_${+new Date()}`;
                }
                return { ..._d, id: index + 1, agendaKey }
            })

            if(newAgendaList.length === 0 && params.page > 1) {
                refresh();
            }
            setAgendaList(newAgendaList);

            setPaginationObject(res.data.data.meta);
            setAgendaLoading((p) => !p)

        } catch (error) {
            console.log(error);
        }
    }

    // Pagination Operation
    const handleChangePage = async (event, newPage) => {
        setAgendaList([])
        setOpenedAgendas('')
        setPage(newPage);
        await getAllAgenda({ page: newPage + 1, perPage: rowsPerPage }, true)
    };

    const handleChangeRowsPerPage = async (event) => {
        setAgendaList([])
        const perPage = parseInt(event.target.value);
        setRowsPerPage(perPage);
        setPage(0)
        setOpenedAgendas('')
        await getAllAgenda({ page: 1, perPage: perPage }, true)
    };


    const filterDateFormat = (e) => {
        const date = dayjs(e).format('YYYY-MM-DD');
        setFilterDate(date)
    };

    const refresh = async (date = '') => {
      setAgendaList([]);
      setPage(0)
      await getAllAgenda({ page: 1, perPage: rowsPerPage }, true, date)
   };
   const refresh_component = async (date = '', action='')=>{
        setAction(null);
        getOpenAgendaDates()
       await getAllAgenda({ page: page +1, perPage: rowsPerPage }, true, date)
        setAction(action)
   }
   const getOpenAgendaDates = ()=>{
    if(openedAgendas.length >0){

        const datesForOpenedAgendas = [];
        openedAgendas.forEach((openedAgenda) => {
        agendaList.forEach((agendaItem) => {
            if (agendaItem.id.toString() === openedAgenda) {
                datesForOpenedAgendas.push(agendaItem.date);
            }
        });
        });
        setOpenedDates(datesForOpenedAgendas)
    }
   }
  const accordionIdModify = ()=>{

    const idsForOpenedAgendas = [];
    if(openedAgendas.length >0){

    for (const agendaItem of agendaList) {
        if (openedDates.includes(agendaItem.date)) {
            idsForOpenedAgendas.push(agendaItem.id.toString());
        }
    }
    setOpenedAgendas(idsForOpenedAgendas);
}
  }

  const editAccordionReload = (getAgenda) =>{
    setReloadAccordion(getAgenda)
  }
  const submitEditAccordionReload = (prevDate, newDate) =>{
    if (prevDate === newDate) {
        setAgendaList(prev => {
            const getIndex = prev.findIndex((_p) => _p.date === prevDate);

            if(getIndex !== -1){
                prev[getIndex].agendaKey = `${prev[getIndex]?.id}_${+new Date()}`
            }

            return [...prev]
        })
    } else {
        setAgendaList(prev => {
            const getIndex1 = prev.findIndex((_p) => _p.date === prevDate);
            prev[getIndex1].agendaKey = `${prev[getIndex1]?.id}_${+new Date()}`

            const getIndex2 = prev.findIndex((_p) => _p.date === newDate);

                if (openedAgendas.includes(prev[getIndex2].id.toString())) {
                    prev[getIndex2].agendaKey = `${prev[getIndex2]?.id}_${+new Date()}`
                }
            return [...prev]
        })
    }
  }

  const CloseCreateAgendaModal = () => {
    setOpenCreateAgendaModal(false)
  }

  const CloseEditAgendaModal = () => {
    setOpenEditAgendaModal(false)
  }

    const refreshFilter = () => {
        if (filterPortfolioId || filterDate || filterProjectId) {
            setAgendaList([])
        }

        setFilterPortfolioId()
        setFilterDate()
        setFilterProjectId()
        setKey(+new Date())
    }

    return (
        <React.Fragment>
            <div className="page-content">
            <Helmet
            onChangeClientState={(newState, addedTags) => {
                try {
                // Check if we added any new link[rel="icon"] elements.
                const newFaviconElems = filter(get(newState, 'linkTags', []), {
                    rel: 'icon',
                })

                if (!newFaviconElems.length) {
                    return
                }

                // Get the href of the last link element we just added, which
                // we assume is the most recently-added favicon.
                const newFaviconHref =
                    newFaviconElems[newFaviconElems.length - 1].href

                // Remove all react-helmet link elements with rel="icon" that
                // do not have the href of our recently-added favicon.
                // If no other favicon elements exist, we don't have to do
                // anything.
                const existingFavicons = document.querySelectorAll(
                    `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
                )

                if (existingFavicons.length) {
                    existingFavicons.forEach(e => e.parentNode.removeChild(e))
                }

                // Remove and re-add the latest link element to make sure
                // the browser uses it.
                const newFaviconElem = document.querySelector(
                    `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
                )

                if (newFaviconElem) {
                    const newFavElement = newFaviconElem.cloneNode(true)
                    newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                        `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<InsertChartOutlinedOutlinedIcon />)}</svg>`
                      )}`
                    const parentElem = newFaviconElem.parentNode
                    parentElem.removeChild(newFaviconElem)
                    parentElem.appendChild(newFavElement)
                }
                } catch (e) {
                console.error(e)
                }
            }}
        >
            {/* Set the favicon using a data URI */}
                    <title>{props.t("Courses & Agenda")}</title>
            {/* <link
            rel="icon"
            type="image/x-icon"
            href={`data:image/svg+xml,${encodeURIComponent(
                `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='${getIconPath(<SettingsOutlinedIcon />)}'/></svg>`
              )}`}
            /> */}
            </Helmet>
                <Container fluid>
                    <div className="mainPageHeader d-flex justify-content-between mb-4 flex-wrap">
                        <BreadCrumb title={props.t("Courses & Agenda")} />
                        <div className="kanbanFilters kanban_agenda_filters d-flex justify-content-between align-items-center flex-wrap">
                            <div className="filterTitle d-flex align-items-center">
                                {/* <i className="ri-filter-2-fill"></i> */}
                                <p className="mb-0 mx-1"> {props.t("Filter by")} </p>
                                <FormControl className="agenda_date_filter" sx={{ m: 1, minWidth: 200, '& .MuiInputBase-root': { height: '38px' } }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker
                                                sx={{ mb: 1 }}
                                                key={'DatePicker-' + key}
                                                className="form-control date_width agenda_filter"
                                                disabled={agendaCreationLoading}
                                                size="small"
                                                format="MM/DD/YYYY"
                                                slotProps={{
                                                    field: { clearable: true },
                                                    onClear: () => {
                                                        setFilterDate(null)
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    filterDateFormat(e)
                                                    setAgendaList([])
                                                    setPage(0)
                                                    setOpenedAgendas('')
                                                }}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </FormControl>
                                {(user?.role?.name === Role.EPMO_OFFICER || user?.role?.name === Role.MENTOR) &&
                                    <div className="task_Filter_autocomplete plSelectTypeField me-2" style={{ minWidth: 200 }}>
                                        <SearchDropDownListPaginationComponent
                                            label={props.t("Cohort")}
                                            searchEnabled={false}
                                            key={'Cohort' + key}
                                            listCall={getAllPortfolios}
                                            size="small"
                                            emitItem={(newValue) => {
                                                setFilterPortfolioId(newValue?.id ?? null)
                                                setAgendaList([])
                                                setPage(0)
                                                setOpenedAgendas('')
                                            }}
                                            apiParams={{
                                                order: "updatedAt",
                                                direction: "desc",
                                                ...((![Role.EPMO_MANAGER, Role.ROOT_ADMIN, Role.VICE_PRESIDENT,
                                                Role.PRESIDENT, Role.PROGRAM_MANAGER, Role.EPMO_OFFICER, Role.PROJECT_MANAGER, Role.MENTOR].includes(user?.role?.name)) && {
                                                    filterFields: "portfolioUser",
                                                    filterInputs: user.id
                                                })
                                            }}
                                        />
                                    </div>
                                }
                                {/* <div className="task_Filter_autocomplete plSelectTypeField me-2" style={{ minWidth: 200 }}>
                                    <SearchDropDownListPaginationComponent
                                        label={props.t("All Startup")}
                                        searchEnabled={false}
                                        key={'All Project-' + key}
                                        listCall={getAllProject}
                                        size="small"
                                        emitItem={(newValue) => {
                                            setFilterProjectId(newValue?.id ?? null)
                                            setAgendaList([])
                                            setPage(0)
                                            setOpenedAgendas('')
                                        }}
                                        apiParams={{
                                            filterFields: ["status"],
                                            filterInputs: [`${ProjectStatuses.DRAFT}, ${ProjectStatuses.ONGOING}`],
                                            order: "id",
                                            direction: "asc",
                                            ...(![Role.EPMO_MANAGER,
                                            Role.ROOT_ADMIN,
                                            Role.VICE_PRESIDENT,
                                            Role.PRESIDENT,
                                            Role.PROGRAM_MANAGER,
                                            Role.EPMO_OFFICER]
                                                .includes(user?.role?.name) &&
                                            {
                                                userId: user?.id
                                            })
                                        }}
                                    />
                                </div> */}
                                <ReplayOutlinedIcon className="me-2" onClick={refreshFilter} />
                            </div>
                            {/* <button className='edit_button d-flex justify-content-center p-2'>
                                <i className="ri-add-line"></i>
                                <p className='mb-0' onClick={toggleAgendaCreationModal}>{props.t("Add New To-Do List")}</p>
                            </button> */}
                            {(user?.role?.name === Role.EPMO_OFFICER || user?.role?.name === Role.MENTOR) &&
                            <Button
                                onClick={toggleAgendaCreationModal}
                                variant="contained"
                                disableelevation="true"
                                startIcon={<AddOutlinedIcon />}
                                className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary"
                                >
                                {props.t("Add New Course")}
                            </Button>
                            }
                        </div>
                    </div>
                    <Row>
                        {
                            agendaList.length > 0 ? (
                                <Col lg={12}>
                                    {agendaList.map((it, ind) => (
                                        <AgendaAccordionComponent
                                            key={it.agendaKey}
                                            ind={ind}
                                            agenda={it}
                                            openedAgendas={openedAgendas}
                                            toggleAgendas={toggleAgendas}
                                            statusList={statusList}
                                            refresh = {refresh_component}
                                            toggleAgendaEditModal={toggleAgendaEditModal}
                                            sendReloadAccordion = {sendReloadAccordion}
                                            editAccordionReload={editAccordionReload}
                                        />
                                    ))}
                                </Col>
                            ) : (!agendaLoading && agendaList.length === 0 ?
                                <Col lg={12}>
                                        <NodataFound text={props.t("You have yet to create your first To-Do Task.")} icon={Ticket} />
                                </Col> :
                                <Col lg={12}>
                                    <Skeleton variant="rounded" className="p-2 m-2 h-50" ></Skeleton>
                                    <Skeleton variant="rounded" className="p-2 m-2 h-50"></Skeleton>
                                    <Skeleton variant="rounded" className="p-2 m-2 h-50"></Skeleton>
                                    <Skeleton variant="rounded" className="p-2 m-2 h-50"></Skeleton>
                                </Col>
                            )
                        }
                    </Row>
                </Container>
                {agendaList.length > 0 &&
                    <div className="d-flex justify-content-center mt-4">
                        <PaginationComponent
                            paginationObject={paginationObject}
                            page={page}
                            handleChangePage={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </div>}
            </div>
            {/* <div>
            <Modal isOpen={openCreateAgendaModal} toggle={toggleAgendaCreationModal}>
                <CreateAgenda
                    isOpen={openCreateAgendaModal}
                    setIsOpen={setOpenCreateAgendaModal}
                    refresh={refresh_component}
                    submitEditAccordionReload={submitEditAccordionReload}
                />
            </Modal>
            </div> */}

            <CreateAgenda open={openCreateAgendaModal} onClose={CloseCreateAgendaModal} refresh={refresh_component} submitEditAccordionReload={submitEditAccordionReload} />

        <EditAgenda
            open={openEditAgendaModal}
            onClose={CloseEditAgendaModal}
            editAgendaId={editAgendaId}
            refresh={refresh_component}
            submitEditAccordionReload={submitEditAccordionReload}
        />


            {/* <AddChallenges
                projectId={projectId}
                open={isChallangesPopupOpen}
                onClose={handleCloseChallengesPopup}
                refresh={handleAddChallanges}
                selectedRow={selectedChallengesRow}
                action={action}
            /> */}
          {/* <Modal isOpen={openEditAgendaModal} toggle={toggleAgendaEditModal} centered backdrop="static">
                <EditAgendaSection
                    isOpen={openEditAgendaModal}
                    setIsOpen={setOpenEditAgendaModal}
                   refresh={refresh}
                    editAgendaId={editAgendaId}
                    submitEditAccordionReload={submitEditAccordionReload}
                />
          </Modal> */}

        </React.Fragment>
    );
};

export default withTranslation()(TodoList);
